module.exports = __webpack_public_path__ + "img/015.b7805a01.jpg";